import { render, staticRenderFns } from "./CentralFlag.vue?vue&type=template&id=10954910&scoped=true"
import script from "./CentralFlag.vue?vue&type=script&lang=js"
export * from "./CentralFlag.vue?vue&type=script&lang=js"
import style0 from "./CentralFlag.vue?vue&type=style&index=0&id=10954910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10954910",
  null
  
)

export default component.exports